module.exports = __webpack_public_path__ + "static/media/ar.c5afd73b.pdf";